module.exports = __webpack_public_path__ + "static/img/jf9.93505cb7.png";